"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useBody = void 0;
var react_1 = __importStar(require("react"));
var Elements_1 = require("../Elements");
var Collapse_1 = __importDefault(require("../Elements/Collapse"));
var FullInfo_1 = __importDefault(require("../Elements/FullInfo"));
var useBody = function (_a) {
    var lazy = _a.lazy, columns = _a.columns, rows = _a.rows, itemsInPage = _a.itemsInPage, fullInfoRows = _a.fullInfoRows;
    var _b = (0, react_1.useState)({}), openRows = _b[0], setOpenRows = _b[1];
    var handleCollapseClick = function (index) {
        setOpenRows(function (prev) {
            var _a;
            return (__assign(__assign({}, prev), (_a = {}, _a[index] = !prev[index], _a)));
        });
    };
    return (0, react_1.useMemo)(function () {
        var displayRows = lazy ? rows.slice(0, itemsInPage) : rows;
        return displayRows.map(function (row, index) {
            var id = (row === null || row === void 0 ? void 0 : row.id) || index;
            var cells = columns.map(function (column, idx) { return (react_1.default.createElement(Elements_1.Cell, { key: "".concat(id, "_").concat(column.field).concat(idx).concat(index) }, row[column.field])); });
            return (react_1.default.createElement(react_1.default.Fragment, { key: id + index },
                react_1.default.createElement(Elements_1.Row, { isOdd: index % 2 === 0, pointer: true, onClick: function () { return handleCollapseClick(index); } },
                    cells,
                    react_1.default.createElement(Collapse_1.default, { keyProp: "collapse_".concat(id, "_").concat(index), isExpanded: openRows[index] })),
                openRows[index] ? (react_1.default.createElement(Elements_1.Row, { isOdd: index % 2 === 0 },
                    react_1.default.createElement(Elements_1.Cell, { colSpan: 5, padding: "0 16px 12px", key: "".concat(index, "_tableData") },
                        react_1.default.createElement(FullInfo_1.default, { data: fullInfoRows[index] })))) : null));
        });
    }, [openRows, columns, rows, itemsInPage, lazy, fullInfoRows]);
};
exports.useBody = useBody;
